import axios from 'axios';
import END_POINT from '../config/endpoints.constants';
import { getErrorMessage } from '../customer-call-sdk/lib/API';
import { VriAPIResponse, VriAPIResult } from '../types';
import { ParticipantType } from '../types/participant.type';

export interface GetParticipantTypeOptions {
    requestId: string;
    participantId: string;
}

export interface GetParticipantTypeResponse extends VriAPIResponse {
    data: {
        participantType: ParticipantType;
        deviceType: string;
        deviceMake: string;
    };
}

export interface GetParticipantTypeResult extends VriAPIResult {
    data?: {
        participantType: ParticipantType;
        deviceType: string;
        deviceMake: string;
    };
}

export async function getParticipantType(
    options: GetParticipantTypeOptions,
): Promise<GetParticipantTypeResult> {
    const result: GetParticipantTypeResult = {};
    try {
        const { data: responseData } = await axios.post<GetParticipantTypeResponse>(
            END_POINT.GET_PARTICIPANT_TYPE,
            options,
        );
        if (responseData.data) {
            result.data = {
                participantType: responseData.data.participantType,
                deviceType: responseData.data.deviceType,
                deviceMake: responseData.data.deviceMake,
            };
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}
